// import { Box, styled, Typography } from "@mui/material";

import { Box, Button, styled, Typography } from "@mui/material";

// export const StyledBox = styled(Box)(({ theme }) => ({
//     width: "100%",
//     padding: "0px 78px",
//     [theme.breakpoints.down("xl")]: {
//         padding: "0px 48px",
//     },
//     [theme.breakpoints.down("md")]: {
//         padding: "23px !important",
//     },
//     [theme.breakpoints.down("sm")]: {
//         paddingBottom: "20px",
//         padding: "23px !important",
//     },
// }));
// export const StyledBoxInner = styled(Box)(({ theme }) => ({
//     border: `1px solid ${theme.palette.custom.lightGrey}`,
//     borderRadius: "10px",
//     padding: "15px",
// }));
// export const StyledEmailBox = styled(Box)(() => ({
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'center',
//     alignItems: 'center',
//     width: '100%',
//     gap: '16px',
//     padding: '20px 0px'
// }));
// export const StyledTypographyWel = styled(Typography)(({ theme }) => {
//     return {
//         fontSize: theme.typography.extraSmall.fontSize,
//         textAlign: "left",
//         display: "block",
//     };
// });
// export const StyleTypographyText = styled(Typography)(({ theme }) => ({
//     color: theme.palette.custom.warning,
//     fontSize: theme.typography.xxLarge.fontSize,
//     fontWeight: theme.typography.fontWeight.semiBold,
//     textAlign: "left",
//     display: "block",

//     [theme.breakpoints.down("xs")]: {
//         fontSize: theme.typography.extraLarge.fontSize,
//     },
// }));
// export const StyleText = styled(Typography)(({ theme }) => ({
//     color: theme.palette.custom.black,
//     fontSize: theme.typography.regular.fontSize,
//     fontWeight: theme.typography.fontWeight.medium,
//     textAlign: "left",
//     display: "block",

//     [theme.breakpoints.down("xs")]: {
//         fontSize: theme.typography.extraLarge.fontSize,
//     },
// }));
// export const StyleMiddleText = styled(Typography)(({ theme }) => ({
//     color: theme.palette.custom.black,
//     fontSize: theme.typography.xLarge.fontSize,
//     fontWeight: theme.typography.fontWeight.semiBold,
//     textAlign: "left",
//     display: "block",

//     [theme.breakpoints.down("xs")]: {
//         fontSize: theme.typography.extraLarge.fontSize,
//     },
// }));
// export const StyleSpan = styled("span")(({ theme }) => ({
//     paddingLeft: "3px",
//     fontWeight: theme.typography.fontWeight.bold,
//     textDecoration: "underline",
//     cursor: "pointer",
//     color: theme.palette.custom.primary
// }));
// export const StyledTypographyDo = styled(Typography)(({ theme }) => ({
//     marginTop: "44.5px",
//     textAlign: "center",
//     [theme.breakpoints.down("sm")]: {
//         marginTop: "30.5px",
//     },

//     fontSize: theme.typography.extraSmall.fontSize,
// }));
export const Wrapper = styled(Box)(() => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}));

export const Card = styled(Box)(({ theme }) => ({
    maxWidth: 480,
    width: "100%",
    padding: theme.spacing(4),
    borderRadius: 12,
    backgroundColor: "#fff",
    boxShadow: "0 4px 16px rgba(0,0,0,0.30)",
    textAlign: "center",
}));

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette.warning.main,
    fontWeight: 600,
    fontSize: "1.5rem",
    marginBottom: theme.spacing(2),
}));

export const VerifiedIcon = styled("img")(() => ({
    width: 120,
    marginBottom: 16,
}));

export const VerifiedText = styled(Typography)(({ theme }) => ({
    fontSize: "1.25rem",
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: 8,
}));

export const Description = styled(Typography)(({ theme }) => ({
    fontSize: "1rem",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(4),
}));

export const StyledButton = styled(Button)(() => ({
    textTransform: "none",
    fontWeight: 500,
}));